import * as actions from '../actions/types';

export const initialState = {
  activities: { data: [], error: null, loading: true },
  activitiesCurrentPage: { data: 1 },
  activitiesFilters: { data: {} },
  activitiesLength: { data: [] },
  activitiesOtherPages: { data: {}, error: null, loading: true },
  activitiesPerPage: { data: 25 },
};

export default function activitiesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_ACTIVITIES:
      return { ...state, activities: action.value };
    case actions.SET_ACTIVITIES_LENGTH:
      return { ...state, activitiesLength: action.value };
    case actions.SET_ACTIVITIES_PER_PAGE:
      return { ...state, activitiesPerPage: action.value };
    case actions.SET_ACTIVITIES_CURRENT_PAGE:
      return { ...state, activitiesCurrentPage: action.value };
    case actions.SET_ACTIVITIES_FILTERS:
      return { ...state, activitiesFilters: action.value };
    default:
      return state;
  }
}
